import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Check, X, ArrowRight } from 'lucide-react';
import api from '@/utils/api';

const RsvpVerifyPage = () => {
  const [params] = useSearchParams();
  const t = params.get('t');
  const [state, setState] = useState({ loading: true, ok: false, editUrl: null, error: '' });

  useEffect(() => {
    if (!t) { setState({ loading: false, ok: false, editUrl: null, error: 'Missing token' }); return; }
    (async () => {
      try {
        const { data } = await api.post('/rsvp/verify-email', { token: t });
        setState({ loading: false, ok: true, editUrl: data.edit_url, error: '' });
      } catch (e) {
        setState({ loading: false, ok: false, editUrl: null, error: e?.response?.data?.detail || 'Verification failed' });
      }
    })();
  }, [t]);

  return (
    <div className="container mx-auto px-4 md:px-8 py-24">
      <Card className="max-w-lg mx-auto border shadow-soft">
        <CardContent className="p-10 text-center">
          {state.loading ? (
            <div className="flex justify-center py-6"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-700" /></div>
          ) : state.ok ? (
            <>
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-secondary-100 to-secondary-50 border border-secondary-200 mb-5">
                <Check className="h-6 w-6 text-secondary-700" />
              </div>
              <h1 className="font-display text-3xl font-bold text-primary-900 mb-2">You're confirmed</h1>
              <p className="text-neutral-600 mb-6">Your email is verified. We've sent your confirmation with a private edit link.</p>
              {state.editUrl && (
                <div className="p-3 rounded-lg bg-neutral-50 border border-neutral-200 text-left mb-6">
                  <div className="text-xs text-neutral-600 font-semibold uppercase tracking-widest mb-1">Edit link (bookmark)</div>
                  <a href={state.editUrl} className="text-sm text-primary-800 break-all underline">{state.editUrl}</a>
                </div>
              )}
              <Button asChild className="bg-gradient-to-r from-secondary-500 to-secondary-600 text-primary-900 font-semibold shadow-gold">
                <Link to="/">Back to Dostination <ArrowRight className="h-4 w-4 ml-2" /></Link>
              </Button>
            </>
          ) : (
            <>
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-accent-50 border border-accent-200 mb-5">
                <X className="h-6 w-6 text-accent-700" />
              </div>
              <h1 className="font-display text-2xl font-bold text-primary-900 mb-2">Link no longer valid</h1>
              <p className="text-neutral-600 mb-6">{state.error}</p>
              <Button asChild variant="outline"><Link to="/events">Browse events</Link></Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default RsvpVerifyPage;
